import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Load, Confirmar } from '../partials/PopUps.js';
import DatePicker from "react-datepicker";

import {HojaReporte} from './TicketCorte';

const VentasDelDiaSucursal = ({sucursalid}) => {
   
   const [_confirmCorte, setConfirmcorte] = useState(false);
   const [printTicket, setPrintTicket] = useState(false);
   const [ elcorte, setElcorte ] = useState([]);
   const [load, setLoad] = useState(false);
   const [formatDate, setFD] = useState('');
   const [date, setDate] = useState(new Date());

   const confirmCorte = () => {
      const __confirmCorte = !_confirmCorte;
      setConfirmcorte(__confirmCorte);
   }
   const generarReport = () => {
      
      setConfirmcorte(!_confirmCorte);
      setLoad(true);
      const parseDate = window.$parseDate(date);
      fetch(window.$api+'/cortedecajaSucursal/'+sucursalid+'_'+parseDate)
		.then(res=>res.json())
		.then(
         response=>{
            const _printTicket = !printTicket;
            setElcorte(response);
            setLoad(false);
            setPrintTicket(_printTicket);
         },
         error=>{
            toast.error('Problemas de conexión intenten más tarde...');
         }
      );
   }
   const closeTicket = () => {
      const _printTicket = !printTicket;
      setPrintTicket(_printTicket);
   }
   const getDate = params => {
      let _fecha = params, _fechaf;
      if(params===null){
         _fecha = new Date();
      }
      const f1 = new Date(new Date());
		const f2 = new Date(params);
      if(f2 > f1){
         _fecha = new Date();
         toast.warning('No puede seleccionar una fecha después, al día de hoy');
      }

      _fechaf = window.$parseDate(_fecha);
      setDate( _fecha );
      setFD( _fechaf );
	}

   return <>
            <div className="xs-6 sm-6 md-7 lg-7">
               <span>corte de caja </span><br/>
               <small style={{margin:'0px',display:'inline-block'}}>Seleccione una fecha para su corte</small>
               <DatePicker
					   dateFormat="dd-MM-yyyy"
						selected={date}
						onChange={(date)=>getDate(date)}
						locale='es'
						className='input-normal'
					/>
               <div className='btn btn-green btn-small' style={{top:'4px'}} onClick={confirmCorte}>Realizar corte</div>
            </div>
            {printTicket&&<HojaReporte data={elcorte} open={printTicket} fecha={formatDate} setOpen={closeTicket}/>}
            <Load display={load} />
            <Confirmar 
               message={'¿Desea realizar el corte de caja?'}
               fadeIn={_confirmCorte}
               saveCaja={generarReport}
               confirm={confirmCorte}
            />
         </>
}
export default VentasDelDiaSucursal